<template>
  <div>
    <!-- 标题 -->
    <h3 v-if="title">{{ title }}</h3>
    <!-- TAB目录 -->
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="menus && menus.length > 0"
    >
      <Menu
        mode="horizontal"
        :active-name="menu_name"
        @on-select="selectMenu"
        style="width: 100%"
      >
        <div v-for="(v, k) in menus"  style="display:inline-block;" :key="k">
          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
            <Badge
              :overflow-count="10000000"
              v-if="v.badge && v.badge.count"
              :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>
    <!-- 操作 -->
    <Row
      :gutter="8"
      style="margin: 20px 0 0 0; width: 100%"
      v-if="actions && actions.length > 0"
    >
      <div
        v-for="(v, k) in actions"
        :key="k"
        style="margin-right: 10px; display: inline-flex"
      >
        <!-- <Col span="3" :xxl="3" :xl="4" :lg="6" :md="8" :sm="12" :xs="12" v-auth="v.auth"> -->
        <Button
          :size="v.size || 'default'"
          :type="v.type || 'warning'"
          v-auth="v.auth"
          :icon="v.icon || ''"
          @click="v.onClick"
          >{{ v.label }}</Button
        >
        <!-- </Col> -->
      </div>
    </Row>

    <ul class="Ul">
      <li v-for="item in arr" :key="item.id" @click="btn(item.id)">
        <img
          :src="item.imgUrl"
          alt=""
          v-show="item.imgUrl == null ? false : true"
        />
        <h3>{{ item.name }}</h3>
        <div :style="{ left: item.imgUrl == null ? '0px' : '170px' }">
          <p v-html="item.content">{{ item.content }}</p>
        </div>
      </li>
    </ul>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "knowledge",
        key: "id",
        url: {
          del: "/admin/system/knowledge",
        },
        output: false,
        order: "createTime",
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/knowledgeBase/add",
        },
      ],
      menus: [
        {
          label: "知识库",
          name: "knowledgeBase_list",
          auth: "system/knowledgeBase/index",
        },
      ],
      arr: [],
    };
  },
  created() {
    this.loadLevelData();
    this.loadLableData();
  },
  methods: {
    search() {
      let q = {};
      $utils.api.load("/admin/system/knowledge/list", q).then((res) => {
        if (res && res.rows) {
          this.arr = res.rows;
          // console.log(this.arr, "-----------------");
        }
      });
    },
    loadLableData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/label/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id + "";
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "label") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    //知识库详情
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/type/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }

          /* for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "type") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          } */
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "knowledgeBase_add", query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "knowledgeBase_edit",
        query: { action: "edit", kv: kv },
      });
    },
    //  handleEdit(currentRow){
    //   $utils.url.push({ name: "knowledgeBase_edit", query: {action: "edit", kv: currentRow.id } });
    // },
    //转单
    toChange(row) {},
    //留言内容
    toInfo(row) {
      $utils.url.push({
        name: "comment_list",
        query: { knowledgeId: row.id },
      });
    },

    //详情
    btn(row) {
      $utils.url.push({
        name: "knowledgeBase_info",
        query: { id: row },
      });
    },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
};
</script>
<style lang="less" scoped>
.Ul {
  margin-top: 10px;
  display: flex;
  width: 1470px;
  justify-content: flex-start;
  flex-wrap: wrap;

  li {
    width: 26.625rem;
    height: 6.25rem;
    background-color: #f5f7fa;
    position: relative;
    cursor: pointer;
    margin-bottom: 10px;
    border-radius: 5px;
    margin-right: 10px;
    padding: 0 10px;

    img {
      border-radius: 5px;
      width: 9.375rem;
      height: 6.25rem;
      padding-right: 10px;
      display: inline-block;
    }
    h3 {
      display: inline-block;
      position: absolute;
      top: 5px;
    }
    .div1 {
      display: inline-block;
      position: absolute;
      top: 30px;
      left: 170px;
      width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    div {
      padding: 0 10px;
      position: absolute;
      top: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
/* .Ul :nth-child(2n) {
  margin-left: 50px;
} */
</style>
